import React from "react";
import { Link, useLocation } from "react-router-dom";
import CfoLanguageToggle from "../cfo/CfoLanguageToggle";
import { useEmpresasLanguageOptional } from "../../context/EmpresasLanguageContext";

const NavbarGeneral = () => {
  const location = useLocation();
  const tipoDesdeState = location.state?.tipo;
  const onEmpresas = location.pathname.startsWith("/empresas");
  const { t } = useEmpresasLanguageOptional();
  const chrome = t.chrome.navbarGeneral;

  const navItems = [
    { name: chrome.personas, path: "/personas" },
    { name: chrome.empresas, path: "/empresas" },
    { name: chrome.valor360, path: "/valor360" },
    { name: chrome.sueldoInteligente, path: "/sueldo-inteligente" },
    { name: chrome.blog, path: "/blog" },
  ];

  const isEmpresasSelected = onEmpresas || tipoDesdeState === "empresas";
  const isEmpresasLangSection = onEmpresas;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 shadow-md hidden lg:flex ${
        isEmpresasSelected ? "bg-[#220365]" : "bg-blue-900"
      } items-center justify-between text-white h-12 px-5 font-bold`}
    >
      <ul className="flex h-full">
        {navItems.map((item) => (
          <li key={item.path} className="h-full">
            <Link
              to={item.path}
              className={`h-full flex items-center rounded-b-xl px-4 ${
                location.pathname.startsWith(item.path)
                  ? isEmpresasSelected && item.path === "/empresas"
                    ? "bg-[#7b41f8] text-white"
                    : "bg-blue-700 text-white"
                  : "hover:bg-blue-800"
              }`}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
      <div className="flex items-center space-x-4 px-4">
        <Link to="/quienes-somos" className="hover:underline">
          {chrome.quienesSomos}
        </Link>
        <Link to="/transparencia" className="hover:underline">
          {chrome.transparencia}
        </Link>
        <Link to="/consumidor" className="hover:underline">
          {chrome.consumidor}
        </Link>
        {isEmpresasLangSection && <CfoLanguageToggle />}
      </div>
    </nav>
  );
};

export default NavbarGeneral;
